import React from "react";
import PropTypes from "prop-types";
import { VideoPlayerAlert } from "../../../../Icons";
import AlertDialog from "./AlertDialog";
import { useState } from "react";

const Alerts = ({ alertData }) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const toggleDialogOpen = (value) => {
		setIsDialogOpen(value);
	};
	return (
		<div style={{ ...(isDialogOpen && { marginBottom: 160, marginRight: "-118px" }) }}>
			<AlertDialog isOpen={isDialogOpen} alertData={alertData} toggleDialogOpen={toggleDialogOpen} />
			<div style={{ height: "100%" }}>
				<div onClick={() => setIsDialogOpen(!isDialogOpen)} data-testid="orion-components-cbcomponents-new-video-player-components-recorded-alerts-alert-div">
					<VideoPlayerAlert customStyles={{ marginLeft: "-3px", position: "absolute", marginTop: 5 }} />
				</div>
			</div>
		</div>
	);
};

Alerts.propTypes = {
	alertData: PropTypes.object
};

export default Alerts;
